
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/snapshot",
      function () {
        return require("private-next-pages/snapshot.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/snapshot"])
      });
    }
  